import classNames from 'classnames'

const getButtonClassList = (props) => {
  return classNames({
    'btn': true,
    'btn-primary': props.primary,
    'btn-cancel-link': props.cancel && props.link,
    'btn-default': props.default,
    'btn-success': props.success,
    'btn-danger': props.danger,
    'btn-default btn-danger-text': props.warning,
    'btn-secondary': props.secondary,
    'is-loading': props.loading
  }, props.qaClasses)
}

const Button = (props) => {
  let options = {
    type: props.type ? props.type : 'button',
    onClick: props.onClick,
    class: getButtonClassList(props),
    style: props.style
  }

  if (props.disabled) options['disabled'] = 'disabled'
  if (props.type) options['type'] = props.type

  return (
    <button {...options}>
      <div class='btn--loader loader' />
      <span class='btn__hide-when-loading'>{props.title || props.children}</span>
    </button>
  )
}

export default Button
